import { throttle } from '../../util/function';
import { desktopHeaderHeight, backendPaddingDesktopTop } from '../../../css/utils/variables_misc.scss';
window.up.compiler('.js-backend_desktop_side_navigation', function (element) {
    if (element instanceof HTMLElement) {
        let previousWindowScrollY = window.scrollY;
        const desktopHeaderHeightInt = parseInt(desktopHeaderHeight, 10);
        const backendPaddingDesktopTopInt = parseInt(backendPaddingDesktopTop, 10);
        const maxInnerElementTopOffset = desktopHeaderHeightInt + backendPaddingDesktopTopInt;
        const adjustInnerElementMargins = throttle(function () {
            const innerElement = element.querySelector('.js-backend_desktop_side_navigation_inner');
            if (innerElement) {
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const innerElementBoundingRect = innerElement.getBoundingClientRect();
                const isElementSticky = element.offsetTop > 0;
                const scrollDelta = window.scrollY - previousWindowScrollY;
                let scrollDirection;
                if (previousWindowScrollY > window.scrollY) {
                    scrollDirection = 'up';
                }
                else {
                    scrollDirection = 'down';
                }
                const updateInnerElementMarginTop = () => {
                    const currentMarginTop = parseInt(innerElement.style.marginTop || '0', 10);
                    let newMarginTop = currentMarginTop - scrollDelta;
                    if (newMarginTop > 0) {
                        newMarginTop = 0;
                    }
                    innerElement.style.marginTop = newMarginTop + 'px';
                };
                if (isElementSticky) {
                    if (scrollDirection === 'down' && innerElementBoundingRect.bottom > windowHeight) {
                        updateInnerElementMarginTop();
                        // this will sometimes scroll more than until the end of innerElement
                        // it doesn't look so terrible and I'm not sure how to prevent it from doing that
                        // while keeping a margin-top only approach and not introducing any jerking
                    }
                    if (scrollDirection === 'up' && innerElementBoundingRect.top < maxInnerElementTopOffset) {
                        updateInnerElementMarginTop();
                    }
                }
                previousWindowScrollY = window.scrollY;
            }
        }, 10);
        window.addEventListener('scroll', adjustInnerElementMargins);
        return () => {
            window.removeEventListener('scroll', adjustInnerElementMargins);
        };
    }
});
window.up.compiler('.js-backend_side_navigation_button_collapse', function (button) {
    const expandedClass = 'expanded';
    const container = document.querySelector(`#${button.getAttribute('aria-controls')}`);
    if (container) {
        const collapse = function () {
            button.setAttribute('aria-expanded', 'false');
            container.classList.remove(expandedClass);
        };
        const expand = function () {
            button.setAttribute('aria-expanded', 'true');
            container.classList.add(expandedClass);
        };
        const setInitialAttrs = function () {
            if (button.getAttribute('aria-expanded') === 'true') {
                expand();
            }
            else {
                collapse();
            }
        };
        const toggleExpanded = function () {
            if (button.getAttribute('aria-expanded') === 'true') {
                collapse();
            }
            else {
                expand();
            }
        };
        setInitialAttrs();
        button.addEventListener('click', toggleExpanded);
        return () => {
            button.removeEventListener('click', toggleExpanded);
        };
    }
});
